<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
  label: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['reveal-more']);

const handleClick = () => {
  emit('reveal-more');
};
</script>

<template>
  <button
    type="button"
    class="events-list__show-more-button"
    @click="handleClick"
  >
    {{ label }}
  </button>
</template>
